module.exports = __webpack_public_path__ + "img/pr-3.7c31bee3.png";